import React, { useMemo } from 'react';
import { useRoute } from '@react-navigation/native';

import MachineSetupDetail from './MachineSetupDetail';
import { GET_MACHINE_SETUP, MODIFY_MACHINE_SETUP } from '../../../../common/graphql/machineSetup';
import { EmptyState, Screen } from '../../../design/components';
import { useUserContext } from '../../../../common/utils/context';
import { PREDEFINED_USER_ROLES } from '../../../../common/constants';

const MachineSetupDetailView = () => {
	const route = useRoute();
	const { machineSetupId } = route.params || {};
	const { user, isAVC, isDriver } = useUserContext();

	const canAccessSetups = useMemo(() => user && (
		user.isSuperAdmin ||
		(isAVC && user.role.name === PREDEFINED_USER_ROLES.ADMIN) ||
		isDriver
	), [user, isAVC, isDriver]);

	if (!canAccessSetups) {
		return (
			<Screen>
				<EmptyState icon="lock" title="You do not have access to this setup." />
			</Screen>
		);
	}

	return (
		<Screen scroll={false}>
			<MachineSetupDetail
				id={machineSetupId}
				query={GET_MACHINE_SETUP}
				modifyMutation={MODIFY_MACHINE_SETUP}
			/>
		</Screen>
	);
};

export default MachineSetupDetailView;
